import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tthhaz7z5x: FaireBrandEntity = {
  token: "b_tthhaz7z5x",
  type: "brand",
  name: "Jungle Club",
  avatarUrl:
    "https://cdn.faire.com/fastly/4377db05f597a5784cca2422c09d901a8d88a5dee520ab647d8b5773ce641ed7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5ad400d2f444663a4ad9be281a918becedbaf7177e2cb6bf60b95ca6c32079db.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4377db05f597a5784cca2422c09d901a8d88a5dee520ab647d8b5773ce641ed7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5ad400d2f444663a4ad9be281a918becedbaf7177e2cb6bf60b95ca6c32079db.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 216,
  isTopShop: true,
  isInsider: true,
  description:
    "After fourteen years in retail, the award winning team at Pigment located in San Diego, have taken the plunge and are are creating their own signature products.  The dream became a reality in the spring of 2022 when they launched sister brands: Jungle Club and Sunshine Studios.\n\nWhere Jungle Club is focused on plant accessories and plant themed gifts, Sunshine Studios is a lifestyle brand dedicated to vintage inspired designs with a distinctly SoCal vibe.  Retail partners can feel confident that the same creative talent and dedication that built Pigment are now focused on growing these two new lines and that accounts will be managed by a seasoned team that is steeped in years of retail experience and rooted in the same level of professionalism and strong values that customers have come to expect from Pigment.\n\nWe’re so excited for this new chapter and immensely grateful for the opportunity to work with you.  ",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:52.675Z",
    importedBy: "entity-db-cli",
  },
};
